import React from 'react'
import { Flex, IconButton, CogIcon, Button } from '@arborswap/uikit'
import MenuButton from './MenuButton'

const NetworkDropdown = () => {
  const t = 'Submit'
  return (
    <Flex>
      <MenuButton />
    </Flex>
  )
}

export default NetworkDropdown